<template>
  <div class="quick-entry" :style="{height: `${listData.length * 49.5}px`}">
    <ul>
      <li v-for="(item, index) in listData" :key="index">
        <a href="javascript:void(0);" v-if="!item.backToTop && item.isWindowOpen" @click="itemClickHandler(item)">
          <img :src="item.icon" @mouseenter="hoverHandle(item, $event)" @mouseleave="blurHandle(item, $event)">
        </a>
        <a :href="item.link" target="_blank" v-if="!item.backToTop && !item.isWindowOpen" >
          <img :src="item.icon" @mouseenter="hoverHandle(item, $event)" @mouseleave="blurHandle(item, $event)">
        </a>
        <a @click="scrollToTop" v-if="item.backToTop" >
          <img :src="item.icon" @mouseenter="hoverHandle(item, $event)" @mouseleave="blurHandle(item, $event)">
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import raf from 'raf';

var easeInOutCubic = function easeInOutCubic(t, b, c, d) {
  var cc = c - b;
  t /= d / 2;
  if (t < 1) {
    return cc / 2 * t * t * t + b;
  } else {
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
  }
};

export default {
  data() {
    return {
      screenHeight: window.screen.availHeight,
      listData: []
    }
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  mounted(){
      this.listData = this.list.filter(x => !x.backToTop).map(x => {return {...x, hover: false}})
      // this.computeData()
      document.addEventListener('scroll',this.computeData)
  },
  beforeDestroy(){
      document.removeEventListener('scroll',this.computeData)
  },
  methods: {
    hoverHandle(item, e) {
      const el = e.target
      el.src = item.texticon
    },
    blurHandle(item, e) {
      const el = e.target
      el.src = item.icon
    },
    itemClickHandler (item) {
      let extra = item.extra && item.extra.split('*')
      let width = 750, height = 648
      if(Array.isArray(extra) && extra.length === 0){
        width = extra[0]
        height = extra[1]
      }
      let left = (window.screen.availWidth - width) / 2
      let top = 60
      window.open(item.link, '_blank', `width=${width},height=${height},left=${left},top=${top}`)
      return
    },
    computeData() {
      const scollTop = this.getCurrentScrollTop()
      const screenHeight = window.screen.availHeight
      if (scollTop > screenHeight) {
        this.listData = this.list
      } else {
        this.listData = this.list.filter(x => !x.backToTop)
      }
    },
    getCurrentScrollTop() {
      return window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
    },
    setScrollTop(value) {
      document.body.scrollTop = value;
      document.documentElement.scrollTop = value;
    },
    scrollToTop(e) {
      var _this2 = this;
      var scrollTop = this.getCurrentScrollTop();
      var startTime = Date.now();
      var frameFunc = function frameFunc() {
        var timestamp = Date.now();
        var time = timestamp - startTime;
        _this2.setScrollTop(easeInOutCubic(time, scrollTop, 0, 450));
        if (time < 450) {
          raf(frameFunc);
        } else {
          _this2.setScrollTop(0);
        }
      };
      raf(frameFunc);
      // this.$emit('click', e);
    },
  },
}
</script>
<style lang="scss" scoped>
.quick-entry{
  position: fixed;
  right: 0;
  top: 170px;
  background: linear-gradient(#3465d6, #3e7ee8);
  width: 48px;
  padding: 0px 4px;
  border-radius: 10px;
  z-index:100;
  
  ul{
    height: 100%;
    display: flex;
    flex-direction: column;

    li{
      flex:1;
      padding: 9px 5px;
      font-size: 15px;
      position: relative;
      border-bottom: 2px solid #618de5;
      
      &:last-child{
        border-bottom: 0;
      }
    }
    
    a{
      color: #fff;
      display: block;
      line-height: 1.2;

      img{
        width:100%;
      }
    }
  }
}
</style>
